'use client';

export function GladlyFaq() {
  const gladlyDomain = process.env.GLADLY_DOMAIN
  const cdn = process.env.ENV === 'prod' ? 'https://cdn.gladly.com' : 'https://cdn.gladly.qa';
  const orgId = process.env.GLADLY_ORG_ID;
  const src = `/gladly-help-center.html?gladlyDomain=${gladlyDomain}&cdn=${cdn}&orgId=${orgId}`;

  return (
    <iframe
      src={src}
      title="Gladly Help Center"
      style={{ width: '100%', height: '1000px', border: 'none' }}
      sandbox="allow-scripts allow-same-origin allow-top-navigation-by-user-activation"
    />
  );
}
